
import IconBrandActive from '~/components/icons/IconBrandActive.vue';
import IconClose from '~/components/icons/IconClose.vue';
export default {
  components: { IconBrandActive, IconClose },
  props: {
    header: {
      type: String,
      required: true
    },
    textOne: {
      type: String,
      required: true
    },
    textTwo: {
      type: String,
      required: true
    }
  }

};
